import axios from "axios";
import { BASE_URL } from "@/composables/url_config";
import { log } from "@/composables/useLog";

export const getLegalDocument = async (token) => {
  log("welcome in getLegalDocument");
  try {
    const url = BASE_URL + '/home/get_legal_document_api';
    const result = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    log("result.data din getLegalDocument");
    log(result.data);
    return result.data;
  } catch (err) {
    log("Error in getLegalDocument");
    log(err);
    return { error: true, message: "Error loading document" };
  }
};

export const updateLegalDocument = async (token, htmlContent) => {
  log("welcome in updateLegalDocument");
  try {
    const url = BASE_URL + '/home/update_legal_document_api';
    const result = await axios.put(url, {
      html_content: htmlContent
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    log("result.data din updateLegalDocument");
    log(result.data);
    return result.data;
  } catch (err) {
    log("Error in updateLegalDocument");
    log(err);
    return { error: true, message: "Error updating document" };
  }
};
